export const contractTexts = {
  et: {
    heading: "Lepingu sisendandmed, ",
    contracts: "RENDILEPINGUD",
    contract: "Rendileping",
    reference: "Viitenumber",
    rate: "Kuine renditasu määr",
    monthly: "kuus",
    start: "Alguskuupäev",
    return: "Tagastamise tähtaeg",
    predicted: "Eeldatav saadavus: ",
    download: "Lae leping alla",
    period: "Rendiperiood (kuudes)",
    periodHelp: "Sisesta rendi kestus kuudes",
    interval: "Arve intervall (sagedus)",
    every: "iga",
    months: "kuud",
    info: "Lisainfo",
    notes: "Lisa vajadusel asjakohased märkused",
    termsok: "Nõustun renditingimustega",
    confirm: "Kinnita, et oled tutvunud ja nõustud renditingimustega.",
    view: "(Tutvu tingimustega)",
    summary: "Kokkuvõte",
    submit: "Sõlmi rendileping",

  }, 
  en: {
    heading: "Agreement's inputs for",
    contracts: "CONTRACTS",
    contract: "Contract",
    reference: "Reference nr",
    rate: "Monthly rate",
    monthly: "per month",
    start: "Start Date",
    return: "Returned before.",
    predicted: "Eeldatav saadavus: ",
    download: "Download Contract",
    period: "Rental Period (months)",
    periodHelp: "Enter rental duration in months",
    interval: "Invoice Interval",
    every: "every",
    months: "months",
    info: "Additional Information",
    notes: "Add any relevant notes",
    termsok: "I have read and agree to the rental terms.",
    confirm: "Please confirm that you are familiar with the rental terms.",
    view: "(View Terms)",
    summary: "Summary",
    submit: "Submit Rental Agreement",
  }
};

/* Contract : Active

Reference nr: 20261515

Rate: $32.00 per month

Start Date: 2026-02-02

Returned before: 2027-01-02 */